import { PRIMARY_BLUE, TEXT_COLOR } from '../../theme';

export const topbarTokens = {
    color: {
        primary: PRIMARY_BLUE,
        primaryHover: '#1A2F73',
        primarySoft: '#EEF2FB',
        primaryBorder: '#C7D0EA',
        primaryFg: TEXT_COLOR,
        fg: TEXT_COLOR,
        fgMuted: TEXT_COLOR,
        fgSubtle: TEXT_COLOR,
        fgFaint: TEXT_COLOR,
        divider: '#E8EAEE',
        border: '#E1E4E8',
        surface: '#ffffff',
        bgSub: '#F4F5F7',
        danger: '#D04A1F',
        accent: '#E68950',
    },
    radius: { sm: 6, md: 10, lg: 14, xl: 20 },
    shadow: {
        sm: '0 1px 2px rgba(15, 17, 35, 0.04)',
        md: '0 1px 2px rgba(15, 17, 35, 0.04), 0 4px 12px rgba(15, 17, 35, 0.04)',
        lg: '0 1px 2px rgba(15, 17, 35, 0.04), 0 12px 32px rgba(15, 17, 35, 0.08)',
    },
    font: {
        sans: '"Inter", ui-sans-serif, system-ui, -apple-system, sans-serif',
    },
    height: 64,
};
